import { CustomText } from "../../ui/CustomText/CustomText";

const URGENT_THRESHOLD_SECONDS = 20;

function formatCountdown(totalSeconds) {
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}:${String(seconds).padStart(2, "0")}`;
}

export default function PinChallengeCountdown({ secondsLeft }) {
  return (
    <CustomText
      c={secondsLeft <= URGENT_THRESHOLD_SECONDS ? "error" : "dimmed"}
      size="sm"
      align="center"
    >
      Expires in {formatCountdown(secondsLeft)}
    </CustomText>
  );
}
